import { Stack, Typography } from '@mui/joy';
import { ArrowCounterClockwise, PencilSimpleLine, Trash } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { useMemo } from 'react';

import { ComponentStatus } from 'bom/enums';
import { IElement } from 'bom/types';
import { EditLineButton, RemoveButton, RestoreButton } from 'jobs/components/JobDetails';
import { IJob, IJobPart } from 'jobs/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  job: IJob;
  element?: IElement;
  isEditable: (data: IJobPart) => boolean;
}

export const ActionsCell = ({ data, job, element, isEditable }: IProps) => {
  const isRowEditable = isEditable(data);

  const isRowDeleted = useMemo(() => data?.status === ComponentStatus.DELETED, [data]);

  if (!data) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} gap={1}>
      {isRowEditable && (
        <EditLineButton
          job={job}
          jobPart={data}
          element={element}
          buttonElement={
            <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
              <PencilSimpleLine />
            </Typography>
          }
        />
      )}

      {!isRowDeleted && (
        <RemoveButton
          jobPart={data}
          buttonElement={
            <Typography color={Color.DANGER} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
              <Trash />
            </Typography>
          }
        />
      )}

      {isRowDeleted && (
        <RestoreButton
          jobPart={data}
          buttonElement={
            <Typography color={Color.SUCCESS} level={Level.BODY_SM} sx={{ cursor: 'pointer' }}>
              <ArrowCounterClockwise weight="bold" />
            </Typography>
          }
        />
      )}
    </Stack>
  );
};
